import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Seo, { breadcrumbLd } from '../components/Seo';
import { MaskedLines, FadeUp, Eyebrow } from '../components/motion';
import Team from '../components/sections/Team';
import { useT } from '../i18n/LangContext';
import { IMG } from '../data/content';

export default function AboutPage() {
  const t = useT();

  return (
    <>
      <Seo title={t['seo.about.title']} description={t['seo.about.desc']}
        jsonLd={[breadcrumbLd(['Home', 'About'])]} />
      <section className="relative overflow-hidden bg-ink">
        <img src={IMG.painter} alt="Reverence Services — Ottawa" className="photo-treat absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/85 to-ink/40" />
        <div className="container-site relative z-10 py-24 md:py-32">
          <Eyebrow>{t['ab.eyebrow']}</Eyebrow>
          <MaskedLines as="h1" className="mt-4 font-serif text-4xl font-semibold leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl"
            lines={[{ text: t['ab.h1a'], cls: 'text-white' }, { text: t['ab.h1b'], cls: 'italic text-gold' }]} />
        </div>
      </section>

      <section className="bg-white py-24 text-ink md:py-32">
        <div className="container-site grid gap-14 lg:grid-cols-2">
          <FadeUp>
            <h2 className="font-serif text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">{t['ab.h2a']} <span className="italic text-gold-dim">{t['ab.h2b']}</span></h2>
          </FadeUp>
          <FadeUp delay={0.1} className="space-y-5 text-base leading-relaxed text-neutral-600">
            <p>{t['ab.p1']}</p>
            <p>{t['ab.p2']}</p>
            <p>{t['ab.p3']}</p>
            <div className="grid grid-cols-3 gap-6 pt-6">
              {[['15+', t['ab.st1']], ['500+', t['ab.st2']], ['2', t['ab.st3']]].map(([n, l]) => (
                <div key={l}><p className="font-serif text-4xl font-semibold text-gold-dim">{n}</p><p className="mt-1 text-xs font-bold uppercase tracking-widest text-neutral-400">{l}</p></div>
              ))}
            </div>
            <div className="mt-10 max-w-sm" style={{ transform: 'rotate(-1.5deg)' }}>
              <img data-testid="about-owner-photo" src="/work/brunel-owner.jpg" alt={t['ab.ownerAlt']} loading="lazy"
                className="w-full rounded-sm border-8 border-white shadow-xl" />
            </div>
          </FadeUp>
        </div>
      </section>

      <Team />

      <section className="bg-ink py-24 text-center">
        <FadeUp>
          <h2 className="font-serif text-4xl font-semibold tracking-tight sm:text-5xl">{t['ab.ctaH2a']} <span className="italic text-gold">{t['ab.ctaH2b']}</span></h2>
          <Link data-testid="about-quote-cta" to="/quote" className="gold-btn mt-8">{t['ab.cta']} <ArrowRight className="h-4 w-4" /></Link>
        </FadeUp>
      </section>
    </>
  );
}
